document.addEventListener('DOMContentLoaded', () => {
    // slick default setting
    let defaulsettings = {
        loop: true,
        speed: 700,
        effect: 'fade',
        fadeEffect: {
            crossFade: true
        },
        navigation: {
            nextEl: '.swiper-prev',
            prevEl: '.swiper-next'
        },
        autoplay: {
            delay: 5000,
            disableOnInteraction: false
        }
    };

    // start slider default
    let allSwipper =[];

    document.querySelectorAll('.swiper-slider').forEach((element,i) => {

        let swiperConfig = element.dataset.swiper ? JSON.parse(element.dataset.swiper) : defaulsettings;
        element.setAttribute(`data-swiper-${i}`,"");
        let swiper = new Swiper(`[data-swiper-${i}]`, swiperConfig);
        allSwipper[i] = swiper;

    });

    let sliderPress = new Swiper('.slider-press__slider', {
        loop: true,
        speed: 700,
        spaceBetween: 0,
        slidesPerView: 1,
        navigation: {
            prevEl: '.arrow-press-prev',
            nextEl: '.arrow-press-next'
        },
        breakpoints: {
            768: {
                slidesPerView: 2,
                spaceBetween: 90
            },
            1024: {
                slidesPerView: 3,
                spaceBetween: 90
            }
        }
    });

    let quadReviews = new Swiper('.reviews__slider',{
        loop: true,
        speed: 700,
        effect: 'fade',
        autoplay: {
            delay: 6000,
        },
        fadeEffect: {
            crossFade: true
        },
        navigation: {
            prevEl: '.reviews-prev',
            nextEl: '.reviews-next'
        }
    });

    let sliderHighlights = new Swiper('.slider-highlights__slider', {
        loop: true,
        speed: 700,        
        navigation: {
            prevEl: '.arrow-highlights-prev',
            nextEl: '.arrow-highlights-next'
        },
        breakpoints: {
            320: {
                slidesPerView: 1
            },
            700: {
                slidesPerView: 2,
                spaceBetween: 120
            },
            1024: {
                slidesPerView: 3,
                spaceBetween: 120
            }
        }
    });

    let sliderCards = new Swiper('.slider-cards__slider', {
        loop: true,
        speed: 700,        
        navigation: {
            prevEl: '.arrow-cards-prev',
            nextEl: '.arrow-cards-next'
        },
        breakpoints: {
            320: {
                slidesPerView: 1
            },
            700: {
                slidesPerView: 2,
            },
            1024: {
                slidesPerView: 3,
            }
        }
    });

    document.querySelectorAll('.rooms__slider').forEach((element, i) => {
        let entryId = element.getAttribute('data-room');
        element.setAttribute(`data-room-swiper-${i}`, "");
        let swiperRooms = new Swiper(`[data-room-swiper-${i}]`,{
            loop: true,
            speed: 700,
            effect: 'fade',
            fadeEffect: {
                crossFade: true
            },
            pagination: {
                el: `.rooms-pagination-${entryId}`,
                clickable: true,
            },
            navigation: {
                prevEl: `.rooms-prev-${entryId}`,
                nextEl: `.rooms-next-${entryId}`
            }
        });
    });

    let swiperSuites = new Swiper('.suites__slider',{
        loop: true,
        speed: 700,
        effect: 'fade',
        fadeEffect: {
            crossFade: true
        },
        navigation: {
            prevEl: `.suites-prev`,
            nextEl: `.suites-next`
        }
    });

    let activeContent;

    let quadGallery = new Swiper('.gallery-quad__slider',{
        speed: 700,
        centeredSlides: true,
        loop: true,
        slidesPerView: 1.2,
        spaceBetween: 10,
        navigation: {
            prevEl: `.gallery-quad-prev`,
            nextEl: `.gallery-quad-next`
        },
        breakpoints: {
            700: {
                slidesPerView: 2,
                spaceBetween: 15
            }
        },
        on: {
            slideChange: function () {
                if (document.querySelector('.js-gallery-description')) {
                    activeContent && activeContent.classList.remove("active");
                    activeContent = document.querySelector('.js-gallery-description').children[this.realIndex];
                    activeContent.classList.add('active');
                }
            }
        }
    });

    let swiperServices = new Swiper('.slider-services__slider',{
        loop: true,
        speed: 700,
        effect: 'fade',
        fadeEffect: {
            crossFade: true
        },
        navigation: {
            prevEl: `.slider-services-prev`,
            nextEl: `.slider-services-next`
        }
    });

    let swiperTreatments = new Swiper('.treatments__slider', {
        loop: true,
        speed: 700,
        slidesPerView: 1,
        spaceBetween: 30,
        fadeEffect: {
            crossFade: true
        },
        navigation: {
            prevEl: `.treatments-prev`,
            nextEl: `.treatments-next`
        },
        breakpoints: {
            700: {
                slidesPerView: 2
            },
            1025: {
                slidesPerView: 3
            }
        }
    });

    let swiperHighlights = new Swiper('.highlights__slider',{
        loop: true,
        speed: 700,
        slidesPerView: 1.4,
        spaceBetween: 20,
        centeredSlides: true,
        fadeEffect: {
            crossFade: true
        },
        navigation: {
            prevEl: `.arrow-highlights-prev`,
            nextEl: `.arrow-highlights-next`
        }
    });

    let swiperPartners = new Swiper('.partners__slider',{
        loop: true,
        speed: 700,
        slidesPerView: 1,
        spaceBetween: 20,
        navigation: {
            prevEl: `.arrow-partners-prev`,
            nextEl: `.arrow-partners-next`
        },
        breakpoints: {
            700: {
                slidesPerView: 2
            },
            1025: {
                slidesPerView: 3
            }
        }
    });

    let swiperVenues = new Swiper('.venues__slider',{
        loop: true,
        speed: 700,
        slidesPerView: 1.2,
        spaceBetween: 15,
        centeredSlides: true,
        fadeEffect: {
            crossFade: true
        },
        navigation: {
            prevEl: `.arrow-venues-prev`,
            nextEl: `.arrow-venues-next`
        }
    });

    let swiperTabs = new Swiper('.quad-tabs__slider',{
        loop: true,
        speed: 700,
        slidesPerView: 1.2,
        spaceBetween: 20,
        centeredSlides: true,
        autoplay: {
            delay: 4000,
        },
        fadeEffect: {
            crossFade: true
        },
        navigation: {
            prevEl: `.tab-slider-prev`,
            nextEl: `.tab-slider-next`
        }
    })

});